import AInput from './Input';
export default AInput;


// WEBPACK FOOTER //
// ./src/packages/Input/index.js